'use strict';

export const APPLICATION_PERMISSION_CLASS_NAME = 'ApplicationPermissionDomain';
export const APPLICATION_PERMISSION_COLLECTION = 'application-permissions';

export function ApplicationPermissionDomainProvider() {
  return {
    $get: [
      'AbstractDomainClass',
      function (AbstractDomainClass) {
        function ApplicationPermissionDomain(data) {
          AbstractDomainClass.call(this, ApplicationPermissionDomain, data);
        }

        AbstractDomainClass.__inheritFrom(ApplicationPermissionDomain, APPLICATION_PERMISSION_CLASS_NAME, APPLICATION_PERMISSION_COLLECTION);

        ApplicationPermissionDomain.$constraints.addConstraints({
          videoChat: {type: 'boolean'},
        });

        return ApplicationPermissionDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/domain/ApplicationPermissionDomain.js